import React from "react";
import { Container, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const Funding = () => {
  return (
    <Container>
      <h2 className="display-6 fw-bold my-4">Funding of APCs</h2>
      <hr />
      <p className="joab-common-para my-4">
        Many institutions and research funding bodies permit the use of grant funds to cover Article Processing Charges (APCs) for publishing open-access articles. Authors are advised to confirm this with their respective institutions prior to submission.
      </p>
      <h4 className="fw-bold mb-3">APC Structure</h4>
      <p className="joab-common-para mb-4">
        Green Publication follows a transparent APC model based on the economic classification of the author's country, in accordance with global standards.
      </p>
      <table className="table mb-4">
        <thead>
          <tr>
            <th>Country Classification</th>
            <th>Article Processing Charge (APC)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Lower-Middle Income</td>
            <td>$1,200 USD</td>
          </tr>
          <tr>
            <td>Upper-Middle Income</td>
            <td>$1,400 USD</td>
          </tr>
          <tr>
            <td>High Income</td>
            <td>$1,700 USD</td>
          </tr>
        </tbody>
      </table>
      <h4 className="fw-bold mb-3">Waiver & Discount Eligibility</h4>
      <p className="joab-common-para mb-4">
        Green Publication is committed to supporting researchers who face genuine financial constraints. We offer waivers or discounts under the following circumstances:
      </p>
      <ol className="joab-common-para mb-4">
        <li>
          <span className="fw-bold">Limited Financial Support</span><br />
          Authors who do not have access to sufficient research or institutional funding may apply for a full or partial waiver. The request must be accompanied by valid documentation confirming the funding limitation.
        </li>
        <li>
          <span className="fw-bold">Authors from Economically Challenged Regions</span><br />
          Discounts or waivers may be granted to authors affiliated with institutions in low or middle-income countries, as classified by global economic indicators.
        </li>
      </ol>
      <p className="joab-common-para mb-4">
        All waiver applications are evaluated individually and granted at the publisher’s discretion.
      </p>
      <h4 className="fw-bold mb-3">Editorial Independence</h4>
      <p className="joab-common-para mb-4">
        The editorial review and acceptance process is entirely independent of the author’s ability to pay APCs. All manuscripts are reviewed based on academic merit and relevance alone.
      </p>
      <h4 className="fw-bold mb-3">Waiver Application Process</h4>
      <p className="joab-common-para mb-4">
        To request a waiver or discount, authors must complete the APC Waiver Application Form and send it to:
      

        <a href="/APCWaiver.docx" download>
          <Button type="button" className="jab_commonbtn my-2 ">Download</Button>
        </a>
        <br />
        Email: <a href="mailto:editor@journalofappliedbioanalysis.com">editor@journalofappliedbioanalysis.com</a>
      </p>
      <p className="joab-common-para mb-4">
        We recommend that authors initiate the waiver discussion at the time of manuscript submission.
      </p>
    </Container>
  );
};

export default Funding;
